var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showOptions
        ? _c("dotted-dropdown", { attrs: { id: "page-header-options" } }, [
            _vm.allowChangePIC
              ? _c(
                  "li",
                  [
                    _c(
                      "DialogSlot",
                      {
                        ref: "change-pic-dialog",
                        attrs: {
                          id: "change-pic-dialog",
                          modalBtnClass: "btn--transparent",
                          modalBtn: _vm.$t("action.changePIC"),
                          modalHeader: _vm.$t("changePIC"),
                          afterOpenModal: _vm.afterOpenModal,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pic-slot-content",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("div", [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("currentPIC"))),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.previousPersonInCharge)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("label", [_vm._v(_vm._s(_vm.$t("newPIC")))]),
                                _vm._v(" "),
                                _c("HKLSelect", {
                                  attrs: {
                                    value: _vm.newPersonInCharge || undefined,
                                    options: _vm.picHklOptions,
                                    showSearch: true,
                                    placeholder: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.newPersonInCharge = $event || ""
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "buttons" }, slot: "buttons" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn--orange close-reveal-modal",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.newPersonInCharge ||
                                    _vm.newPersonInCharge ===
                                      _vm.previousPersonInCharge,
                                },
                                on: { click: _vm.changePIC },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.ok")))]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSubstitute ? _c("li", [_vm._t("substitute")], 2) : _vm._e(),
            _vm._v(" "),
            _vm.allowCancel
              ? _c(
                  "li",
                  [
                    _c(
                      "DialogSlot",
                      {
                        ref: "cancel-dialog",
                        attrs: {
                          id: "page-header-cancel-dialog",
                          modalBtnClass: "btn--transparent",
                          modalBtn: _vm.cancelOption,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "slot-content",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("span", { staticClass: "content-message" }, [
                              _vm._v(_vm._s(_vm.confirmCancelMsg)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "buttons" }, slot: "buttons" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn--orange close-reveal-modal",
                                attrs: { type: "button" },
                                on: { click: _vm.cancelItem },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }